import React from 'react';
import {Link} from "@mui/material";
import {EditCompanyProfileRowGap10} from "./EditCompanyProfile/style";

const ViewLegalAgreement = (props) => {
  const {classes, account, legalAgreementFile} = props;

  return (
    <EditCompanyProfileRowGap10 item className={classes}>
      {
        legalAgreementFile ? <Link
          href={URL.createObjectURL(legalAgreementFile)}
          target="_blank"
          rel="noopener noreferrer"
        >
          View Uploaded Legal Agreement
        </Link> : account.supplierLegalAgreementFileName && <Link
          href={`https://s3-us-west-1.amazonaws.com/securspace-files/legal-agreements/${account.supplierLegalAgreementFileName}`}
          target="_blank"
          rel="noopener noreferrer"
        >
          View Current Legal Agreement
        </Link>
      }
    </EditCompanyProfileRowGap10>
  );
}

export default ViewLegalAgreement;
